
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!outcomes.outcome_group_form";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'outcomes/outcomeGroupForm';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing;


  buffer += "<form action=\"";
  if (helper = helpers.url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" class=\"outcome_group\" method=\"post\">\n  <label for=\"outcome_group_title\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("outcomes.outcome_group_form")
  },data:data},helper ? helper.call(depth0, "title", "Name this group", options) : helperMissing.call(depth0, "t", "title", "Name this group", options)))
    + ":</label>\n  <input id=\"outcome_group_title\" class=\"outcome_title\" name=\"title\" size=\"50\" type=\"text\" placeholder=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "new_outcome_group_af59f145", "New Outcome Group", options) : helperMissing.call(depth0, "t", "new_outcome_group_af59f145", "New Outcome Group", options)))
    + "\" value=\"";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n  <label for=\"outcome_group_description\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("outcomes.outcome_group_form")
  },data:data},helper ? helper.call(depth0, "group_description", "Describe this group", options) : helperMissing.call(depth0, "t", "group_description", "Describe this group", options)))
    + ":</label>\n  <textarea cols=\"40\" id=\"outcome_group_description\" name=\"description\" rows=\"20\" style=\"width: 100%; height: 150px;\">";
  if (helper = helpers.description) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.description); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</textarea>\n  <div class=\"button-container pull-right\">\n    <button type=\"button\" class=\"btn cancel_button\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("outcomes.outcome_group_form")
  },data:data},helper ? helper.call(depth0, "#buttons.cancel", "Cancel", options) : helperMissing.call(depth0, "t", "#buttons.cancel", "Cancel", options)))
    + "</button>\n    <button type=\"submit\" class=\"btn btn-primary submit_button\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("outcomes.outcome_group_form")
  },data:data},helper ? helper.call(depth0, "#buttons.save", "Save", options) : helperMissing.call(depth0, "t", "#buttons.save", "Save", options)))
    + "</button>\n  </div>\n</form>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  